<template>
  <div id="nav">
    <div class="nav">
      <div class="logo"><img src="/images/logo.png"></div>
      <div class="nav-ul">
        <ul >
          <li :class="index==0?'active':''" @click="navSwitch(0)">首页</li>
          <li :class="index==1?'active':''" style="margin-left: 50px;" @click="navSwitch(1)">商城</li>
          <li :class="index==2?'active':''" style="margin-left: 50px;" @click="navSwitch(2)">充值</li>
          <div class="login" style="margin-left: 30px;" @click="navSwitch(3)" v-if="user.user_name==undefined" ><img src="/images/login.png"></div>
          <div class="login" style="margin-left: 30px;" v-else>
            <Dropdown @on-click="loginOut">
                <img :src="user.avatar" style="width: 30px;height: 30px;margin-top: 15px">
              <DropdownMenu slot="list">
                <DropdownItem style="width: 100%;" name="username">{{ user.user_name }}</DropdownItem>
                <DropdownItem style="width: 100%;" name="loginOut">退出</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
    };
  },
  props: {
    msg: String
  },
  computed :{
    index(){
      return this.$route.meta.index;
    },
    user(){
      return this.$store.getters.getUserInfo;
    }
  },
  methods:{
    navSwitch(num){
      switch (num) {
        case 0: this.$router.push({'path':'/'});break;
        case 1: this.$router.push({'path':'/shop'});break;
        case 2: this.$router.push({'path':'/pay'});break;
        case 3: this.$router.push({'path':'/login'});break;
      }
    },
    loginOut(name){
      if(name === 'loginOut'){
        this.$store.dispatch("loginOut");
        this.$router.push({'path':'/login'});
      }

    }
  }
}
</script>


<style scoped>
  .nav{
    width: 100%;
    position: relative;
  }
  .nav:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #dcdee2;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .logo{
    float: left;
    width: 50%;
    height: 60px;
    background-color: #fff;
  }
  .logo img{
    margin-top: 5px;
  }
  .nav-ul{
    width: 50%;
    float: left;
  }
  .nav-ul ul{
    background: #fff;
    height: 60px;
    line-height: 60px;
    display: block;
    margin: 0;
    padding: 0;
    outline: 0;
    list-style: none;
    color: #515a6e;
    font-size: 14px;
    z-index: 900;
  }
  .nav-ul ul li{
    height: inherit;
    line-height: inherit;
    border-bottom: 2px solid transparent;
    color: #515a6e;
    float: left;
    padding: 0 20px;
    cursor: pointer;
    z-index: 3;
    transition: all .2s ease-in-out;
    display: block;
    outline: 0;
    list-style: none;
    font-size: 14px;
  }
  .login{
    height: inherit;
    margin-left: 30px;
    float: left;
    cursor: pointer;
  }
  .login img{
    width: 85%;
    height: 85%;
    margin-top: 5px;
  }
  .active{
    color: #ff5e49 !important;
    border-bottom: 3px solid #ff5e49 !important;
  }
</style>
